import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const IP_LOCATION_BASE_URL = 'https://ipapi.co/';
const IP_LOCATION_PATH =
    'json/?key=1OdGIdZhDSYsmtIfHJW6QeXtxKCLBgmUK60Oxv8RpbU6TTqy4a';
export const IP_LOCATION_ENDPOINT = `${IP_LOCATION_BASE_URL}${IP_LOCATION_PATH}`;

export type IPLocationShape = {
    ip: string;
    city: string;
    region: string;
    country: string;
    country_name: string;
    country_code: string;
    continent_code: string;
    currency: string;
};

// Define a service using a base URL and expected endpoints
export const IPLocationApi = createApi({
    reducerPath: 'ipLocation',
    baseQuery: fetchBaseQuery({ baseUrl: IP_LOCATION_BASE_URL }),
    endpoints: (builder) => ({
        getLocation: builder.query<IPLocationShape, void>({
            query: () => ({
                url: IP_LOCATION_PATH,
            }),
        }),
    }),
});

export const { useGetLocationQuery } = IPLocationApi;
